import {Client} from "../../domain/model/client";

interface IGetAllClientsByClientResponse {
    clients: Client[];
}
class GetAllClientsByClientResponse implements IGetAllClientsByClientResponse {
    public clients: Client[];
}

interface ICreateClientByClientResponse {
    clients: Client[];
}
class CreateClientByClientResponse implements ICreateClientByClientResponse {
    public clients: Client[];
}

interface IUpdateRoleClientByClientResponse {
    clients: Client[];
}
class UpdateRoleClientByClientResponse implements IUpdateRoleClientByClientResponse {
    public clients: Client[]
}

interface IDeleteClientByClientResponse {
    clients: Client[];
}
class DeleteClientByClientResponse implements IDeleteClientByClientResponse {
    public clients: Client[]
}

export {
    GetAllClientsByClientResponse,
    CreateClientByClientResponse,
    UpdateRoleClientByClientResponse,
    DeleteClientByClientResponse,
}


// WEBPACK FOOTER //
// ./src/presentation/response/clients_response.ts